






























































































































































































































































































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import clientsModule from "@/store/modules/client-module";
import { clients } from "@/shared/dtos/clients";
import { crm_oportunidades } from "@/shared/dtos/crm_oportunidades";
import TiendaOnlineClientesModule from "@/store/modules/TiendaOnlineClientes-module";
import { RouterNames } from "@/router/routernames";
import { getTexto } from "@/views/procesos/ProcessoNums";

@Component({})
export default class ClienteFicha extends Vue {
  public tabActivo: number = 0;
  public guardando: boolean = false;
  public guardandoNota: boolean = false;
  public cargando: boolean = false;
  public nuevaNota: string = "";
  public activePanels: number = 0;
  public itemsVerificados: number[] = [];
  public estadosProductos: Record<string, string> = {};
  public perfilesCliente: any[] = [];
  public generandoPerfil: boolean = false;
  public compactando: boolean = false;

  // CRM/ERP extras
  public dialogOportunidad: boolean = false;
  public guardandoOp: boolean = false;
  public generandoOpIA: boolean = false;
  public nuevaOp: any = { titulo: "", valor_estimado: 0, estado_pipeline: "nuevo", probabilidad_cierre: 50 };
  public filtroTipoEvento: string = "";

  public estadoLeadOpciones = ["nuevo", "contactado", "cualificado", "perdido"];
  public origenOpciones = ["web", "tienda", "telefono", "referido"];

  public headersVentasERP = [
    { text: "Tipo", value: "tipo_documento", width: 110 },
    { text: "Fecha", value: "datecreated", width: 100 },
    { text: "Beneficio Neto", value: "beneficio_neto", width: 120 },
    { text: "Total", value: "total", width: 100 },
    { text: "Estado", value: "estado", width: 110 },
    { text: "", value: "acciones", sortable: false, width: 60 },
  ];

  public headersTelemetria = [
    { text: "Tipo evento", value: "tipo_evento", width: 160 },
    { text: "URL / Detalle", value: "url_pagina" },
    { text: "Fecha", value: "datecreated", width: 120 },
  ];

  public readonly slotVentasTipo: string = "item.tipo_documento";
  public readonly slotVentasFecha: string = "item.datecreated";
  public readonly slotVentasBeneficio: string = "item.beneficio_neto";
  public readonly slotVentasTotal: string = "item.total";
  public readonly slotVentasEstado: string = "item.estado";
  public readonly slotVentasAcciones: string = "item.acciones";
  public readonly slotTelemetriaFecha: string = "item.datecreated";
  public readonly slotTelemetriaTipo: string = "item.tipo_evento";

  public readonly slotTotalVenta: string = "item.base_imponible";
  public readonly slotEstadoPres: string = "item.estado";
  public readonly slotPresFecha: string = "item.datecreated";

  public headersPresupuestos = [
    { text: "ID", value: "id", width: 70 },
    { text: "Base imponible", value: "base_imponible" },
    { text: "Estado", value: "estado" },
    { text: "Notas", value: "notas" },
    { text: "Fecha", value: "datecreated" },
  ];

  public get idClient(): number {
    return Number(this.$route.params.id);
  }

  public get clienteActual(): clients {
    return clientsModule.clients;
  }

  public get carritos(): any[] {
    return clientsModule.carritosByClient;
  }

  public get presupuestos(): any[] {
    return clientsModule.ventasCabeceraByClient.filter((v: any) => v.tipo_documento === 'presupuesto');
  }

  public get notas(): any[] {
    return clientsModule.notasByClient;
  }

  public get cartItems(): any[] {
    return clientsModule.cartItemsByClient;
  }

  public get totalGastado(): string {
    const total = this.presupuestos.reduce((s: number, p: any) => s + (Number(p.base_imponible) || 0), 0);
    return total.toFixed(2) + " €";
  }

  public get timeline(): any[] {
    const eventos: any[] = [];

    this.carritos.forEach((c: any) => {
      eventos.push({
        color: "blue", icon: "mdi-cart",
        titulo: "Carrito #" + c.id + " — " + (c.state === "current" ? "Activo" : "Finalizado"),
        descripcion: c.note || "",
        fecha: this.formatFecha(c.datecreated),
        _ts: new Date(c.datecreated).getTime(),
      });
    });

    this.presupuestos.forEach((p: any) => {
      eventos.push({
        color: "green", icon: "mdi-file-document",
        titulo: "Presupuesto #" + p.id + " — " + Number(p.base_imponible || 0).toFixed(2) + " €",
        descripcion: p.notas || (p.estado || ""),
        fecha: this.formatFecha(p.datecreated),
        _ts: new Date(p.datecreated).getTime(),
      });
    });

    this.notas.forEach((n: any) => {
      eventos.push({
        color: "orange", icon: "mdi-note-text",
        titulo: "Nota",
        descripcion: n.texto,
        fecha: this.formatFecha(n.datecreated),
        _ts: new Date(n.datecreated).getTime(),
      });
    });

    return eventos.sort((a, b) => b._ts - a._ts);
  }

  public async created() {
    if (this.idClient > 0) {
      this.cargando = true;
      await Promise.all([
        clientsModule.getclients(this.idClient),
        clientsModule.getCarritosByClient(this.idClient),
        clientsModule.getNotasByClient(this.idClient),
        clientsModule.getCartItemsByClient(this.idClient),
        clientsModule.getPerfilesByClient(this.idClient),
        clientsModule.getOportunidadesByClient(this.idClient),
        clientsModule.getVentasCabeceraByClient(this.idClient),
        clientsModule.getTelemetriaByClient(this.idClient),
      ]);
      this.perfilesCliente = clientsModule.perfilesByClient;
      this.cargando = false;
      this.preloadEstados();
    } else {
      clientsModule.onGetclients(new clients());
    }
  }

  public async guardar() {
    this.guardando = true;
    try {
      if (this.clienteActual.isNewItem()) {
        await clientsModule.guardarclients(this.clienteActual);
      } else {
        await clientsModule.modificarclients(this.clienteActual);
      }
      this.$router.push({ name: "crm_clients_lista" });
    } finally {
      this.guardando = false;
    }
  }

  public async agregarNota() {
    const texto = this.nuevaNota.trim();
    if (!texto) return;
    this.guardandoNota = true;
    try {
      await clientsModule.guardarNota({ client_id: this.idClient, texto });
      this.nuevaNota = "";
      await clientsModule.getNotasByClient(this.idClient);
    } finally {
      this.guardandoNota = false;
    }
  }

  public async eliminarNota(id: number) {
    await clientsModule.eliminarNota(id);
    await clientsModule.getNotasByClient(this.idClient);
  }

  public itemsDeCarrito(cartId: number): any[] {
    return this.cartItems.filter((i: any) => i.cart_id === cartId);
  }

  public totalCarrito(cartId: number): string {
    const total = this.itemsDeCarrito(cartId).reduce(
      (s: number, i: any) => s + Number(i.line_total || i.qty * i.unit_price), 0
    );
    return total.toFixed(2);
  }

  public totalCarritoVerificado(cartId: number): string {
    return (parseFloat(this.totalCarrito(cartId)) * 1.05).toFixed(2);
  }

  // Parsea el product_snapshot JSON del item
  private snapProduct(item: any): any {
    if (!item || !item.product_snapshot) return {};
    try { return JSON.parse(item.product_snapshot); } catch (e) { return {}; }
  }

  public snapImage(item: any): string {
    const p = this.snapProduct(item);
    return p.large || p.imagenPrincipal || "";
  }

  public snapTitle(item: any): string {
    const p = this.snapProduct(item);
    return p.titulo_producto || p.name || p.descripcion || ("Producto #" + (item.product_id || "?"));
  }

  public snapLpn(item: any): string {
    return this.snapProduct(item).lpn || "";
  }

  public verificarCarrito(cart: any) {
    if (this.itemsVerificados.indexOf(cart.id) === -1) {
      this.itemsVerificados.push(cart.id);
    }
  }

  public generarPresupuesto(cart: any) {
    this.$router.push({
      name: RouterNames.ventas_cabecera_formulario,
      params: { id: "nuevo" },
      query: { id_carrito: String(cart.id) },
    });
  }

  private async preloadEstados() {
    const ids: number[] = [];
    for (var i = 0; i < this.cartItems.length; i++) {
      var pid = this.cartItems[i].product_id;
      if (pid && ids.indexOf(pid) === -1) ids.push(pid);
    }
    if (ids.length === 0) return;
    try {
      const dic = await TiendaOnlineClientesModule.getEstadosProductos(ids);
      if (dic) {
        var keys = Object.keys(dic);
        for (var k = 0; k < keys.length; k++) {
          var key = keys[k];
          this.$set(this.estadosProductos, key, getTexto(dic[Number(key)]));
        }
      }
    } catch (e) {
      // silencioso
    }
  }

  public formatFecha(fecha: string): string {
    if (!fecha) return "-";
    return new Date(fecha).toLocaleDateString("es-ES", {
      day: "2-digit", month: "2-digit", year: "numeric",
    });
  }

  // ── CRM/ERP getters ─────────────────────────────────────────────────────
  public get oportunidades(): any[] {
    return clientsModule.oportunidadesByClient;
  }

  public get ventasERP(): any[] {
    return clientsModule.ventasCabeceraByClient;
  }

  public get telemetria(): any[] {
    return clientsModule.telemetriaByClient;
  }

  public get tiposEventoFiltro(): string[] {
    const tipos = new Set<string>();
    this.telemetria.forEach((t: any) => { if (t.tipo_evento) tipos.add(t.tipo_evento); });
    return Array.from(tipos);
  }

  public get telemetriaFiltrada(): any[] {
    if (!this.filtroTipoEvento) return this.telemetria;
    return this.telemetria.filter((t: any) => t.tipo_evento === this.filtroTipoEvento);
  }

  // ── CRM/ERP methods ──────────────────────────────────────────────────────
  public async guardarOportunidad() {
    if (!this.nuevaOp.titulo) return;
    this.guardandoOp = true;
    try {
      const payload = new crm_oportunidades(Object.assign({}, this.nuevaOp, { client_id: this.idClient, origen_ia: 0 }));
      await clientsModule.guardarOportunidad(payload);
      await clientsModule.getOportunidadesByClient(this.idClient);
      this.dialogOportunidad = false;
      this.nuevaOp = { titulo: "", valor_estimado: 0, estado_pipeline: "nuevo", probabilidad_cierre: 50 };
    } finally {
      this.guardandoOp = false;
    }
  }

  public async eliminarOportunidad(id: number) {
    if (!confirm("¿Eliminar esta oportunidad?")) return;
    await clientsModule.eliminarOportunidad(id);
    await clientsModule.getOportunidadesByClient(this.idClient);
  }

  public async generarOportunidadIA() {
    this.generandoOpIA = true;
    try {
      const { ssmHttpService } = await import("@/shared/services/http-service");
      const { API } = await import("@/shared/api");
      await ssmHttpService.post(API.crm_oportunidades + "generarIA/" + this.idClient, {});
      await clientsModule.getOportunidadesByClient(this.idClient);
    } catch (e) {
      // silencioso — AXEL puede generar oportunidades vía MCP
    } finally {
      this.generandoOpIA = false;
    }
  }

  public nuevoDocumentoERP() {
    (this as any).$router.push({
      name: RouterNames.ventas_cabecera_formulario,
      params: { id: "nuevo" },
      query: { client_id: String(this.idClient) },
    });
  }

  public editarDocumentoERP(item: any) {
    (this as any).$router.push({
      name: RouterNames.ventas_cabecera_formulario,
      params: { id: String(item.id) },
    });
  }

  public colorEstado(estado: string): string {
    const m: Record<string, string> = { aprobado: "green", pendiente: "orange", rechazado: "red" };
    return m[estado] || "grey";
  }

  public colorEstadoClass(estado: string): string {
    const m: Record<string, string> = { aprobado: "estado-confirmado", pendiente: "estado-borrador", rechazado: "estado-error" };
    return m[estado] || "estado-borrador";
  }

  public async generarPerfil() {
    this.generandoPerfil = true;
    try {
      await clientsModule.generarPerfilCliente(this.idClient);
      await clientsModule.getPerfilesByClient(this.idClient);
      this.perfilesCliente = clientsModule.perfilesByClient;
    } finally {
      this.generandoPerfil = false;
    }
  }

  public async compactarPerfiles() {
    this.compactando = true;
    try {
      await clientsModule.compactarPerfilCliente(this.idClient);
      await clientsModule.getPerfilesByClient(this.idClient);
      this.perfilesCliente = clientsModule.perfilesByClient;
    } finally {
      this.compactando = false;
    }
  }
}
